export const SENTRY_DSN =
  "https://2e1b45d55c0b4f22a4e961c889497d7d@sentry.io/1499508";
